class CollectionSeoHeading extends HTMLElement {
	connectedCallback() {
		this.measureCopy = this.querySelector(
			".collection__seo-heading-description__measure .collection__seo-heading-description__copy"
		);
		if (!this.measureCopy) return;

		this.addEventListener("click", this.onClick);
		this.resizeObserver = new ResizeObserver(() => this.update());
		this.resizeObserver.observe(this.measureCopy);
		this.update();
	}

	disconnectedCallback() {
		this.resizeObserver?.disconnect();
		this.removeEventListener("click", this.onClick);
	}

	onClick = () => {
		if (this.dataset.expandable !== "true") return;
		this.dataset.state = this.dataset.state === "collapsed" ? "expanded" : "collapsed";
	};

	update() {
		const isOverflowing = this.measureCopy.scrollHeight > this.measureCopy.clientHeight;

		this.dataset.expandable = String(isOverflowing);
		if (!isOverflowing) this.dataset.state = "collapsed";
	}
}

if (!customElements.get("collection-seo-heading")) {
	customElements.define("collection-seo-heading", CollectionSeoHeading);
}
